export default __webpack_public_path__ + "static/media/failureMobile_bg.59562508.jpg";